import { FC, ReactNode, createContext, useEffect } from "react";

interface PopoutRootProps {
    children: ReactNode
    activePopout: string | null
}

const DEFAULT_VALUE = null

export const PopoutRootContext = createContext<string | null>(DEFAULT_VALUE);

export const PopoutRoot: FC<PopoutRootProps> = ({
    children,
    activePopout
}) => {
    useEffect(() => {
        if (activePopout) {
            // Сохраняем текущую ширину body для предотвращения скачка
            const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
            
            // Блокируем скролл и компенсируем ширину скроллбара
            document.body.style.overflow = 'hidden';
            document.body.style.paddingRight = `${scrollbarWidth}px`;
        } else {
            // Восстанавливаем скролл
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
        }

        // Cleanup при размонтировании
        return () => {
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
        };
    }, [activePopout]);

    return (
        <PopoutRootContext.Provider
            value={activePopout}
        >
            <div className="popoutRoot">
                {children}
            </div>
        </PopoutRootContext.Provider>
    )
}